<template>
  <div>
    <v-toolbar color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Mundo Albercas POS</v-toolbar-title>
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" absolute temporary width="280">
      <!-- Sección de Perfil de Usuario -->
      <v-list-item class="py-2">
        <v-list-item-avatar color="grey lighten-2">
          <v-img src="../assets/no-pic.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content v-if="authUserData">
          <v-list-item-title class="font-weight-bold">
            {{ authUserData.user_claims.firstname }} {{ authUserData.user_claims.lastname }}
          </v-list-item-title>
          <v-list-item-subtitle class="caption primary--text text--darken-1">
            <v-icon small color="primary" class="mr-1">mdi-storefront</v-icon>
            {{ storeName }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Lista de Navegación Organizada -->
      <v-list nav>
        <!-- BLOQUE 1: OPERACIONES DE TIENDA -->
        <v-subheader
          v-if="canViewCarrito || canViewClientDeliveries"
          class="text-overline font-weight-black pl-2"
        >Ventas</v-subheader>

        <v-list-item to="/pos" v-if="canViewCarrito" color="primary">
          <v-list-item-icon>
            <v-icon>mdi-point-of-sale</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Carrito</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Nueva funcionalidad: Mercancía pagada pero no entregada -->
        <v-list-item to="/deliveries" v-if="canViewClientDeliveries" color="primary">
          <v-list-item-icon>
            <v-icon>mdi-truck-delivery</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Entrega de Productos</v-list-item-title>
          </v-list-item-content>
          <!-- Badge opcional para alertas de entregas críticas retrasadas -->
          <v-list-item-action v-if="pendingDeliveriesCount > 0">
            <v-badge color="error" :content="pendingDeliveriesCount" inline></v-badge>
          </v-list-item-action>
        </v-list-item>

        <v-divider class="my-2" v-if="showingBothMenus"></v-divider>

        <!-- BLOQUE 2: LOGÍSTICA & ALMACÉN
        <v-subheader class="text-overline font-weight-black pl-2">Logística</v-subheader>

        <! -- Nueva funcionalidad: Traspasos entrantes de almacén u otras sucursales - ->
        <v-list-item to="/transfers" v-if="canViewPos" color="primary">
          <v-list-item-icon>
            <v-icon>mdi-swap-horizontal</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Traspasos Sucursales</v-list-item-title>
          </v-list-item-content>
          <!- - Badge reactivo para alertar la llegada de mercancía -- >
          <v-list-item-action v-if="incomingTransfersCount > 0">
            <v-badge color="info" :content="incomingTransfersCount" inline></v-badge>
          </v-list-item-action>
        </v-list-item>

        <v-divider class="my-2"></v-divider>
        -->

        <!-- BLOQUE 3: CONTROL DE CAJA Y AJUSTES -->
        <v-subheader
          v-if="canViewPos"
          class="text-overline font-weight-black pl-2"
        >Caja y Sistema</v-subheader>

        <v-list-item v-if="canViewPos" to="/cash-start" color="primary">
          <v-list-item-icon>
            <v-icon>mdi-cash-register</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Inicio de caja</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="canViewPos" to="/cash-closing" color="primary">
          <v-list-item-icon>
            <v-icon>mdi-file-document-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Corte de caja</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="canViewPos" to="/configuration" color="primary">
          <v-list-item-icon>
            <v-icon>mdi-cog-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Configuración</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout" class="mt-4 error--text">
          <v-list-item-icon>
            <v-icon color="error">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { TokenUtils } from '@/utils/TokenUtils';
import UserService from '@/services/UserService';
import SettingsService from '../services/SettingsService';

export default {
  name: 'AppNavigation',
  data: () => ({
    drawer: null,
    storeName: '',
    // Datos mockeados para los badges del menú.
    // Puedes conectarlos a tu estado global de Vuex más adelante.
    incomingTransfersCount: 5,
  }),
  computed: {
    ...mapGetters({
      authUserData: 'authUserData',
      canViewCarrito: 'canViewCarrito',
      canViewPos: 'canViewPos',
      canViewClientDeliveries: 'canViewClientDeliveries',
    }),
    pendingDeliveriesCount() {
      return this.$store.getters['notifications/notificationCount'];
    },
    showPOSMenus() {
      return this.canViewPos;
    },
    showCartMenus() {
      return this.canViewCarrito || this.canViewClientDeliveries;
    },
    showingBothMenus() {
      return this.showPOSMenus && this.showCartMenus;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('notifications/disconnect');
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push('/login');
    },
  },
  async mounted() {
    const payload = TokenUtils.getJwtData();
    if (!payload || !payload.user_claims) {
      this.$router.push('/login');
      return;
    }

    this.storeName = localStorage.getItem('storeName');
    const ticketJson = localStorage.getItem('ticket');

    if (!this.storeName || !ticketJson) {
      this.$router.push('/login');
      return;
    }

    this.$store.dispatch('setTicketData', JSON.parse(ticketJson));
    this.$store.dispatch('setAuthUserData', payload);

    const { identity: userId } = TokenUtils.getJwtData();
    const attributes = await UserService.getUserAttributes(userId);
    this.$store.dispatch('setAttributes', attributes);

    const stores = await SettingsService.getStores();
    this.$store.dispatch('setStores', stores);

    this.$store.dispatch('deliveries/fetchPendingCount');
  },
};
</script>
